<template>
    <div class="column is-half is-offset-one-quarter">
        <transition name="fade">
            <div class="notification" 
                v-bind:class="{ 'is-danger': notification.isError, 'is-success': !notification.isError }" 
                v-if="this.notification.msg !== ''">
            {{notification.msg}}
            </div>
        </transition>
        <form class="box" v-on:submit.prevent>
            <div class="field">
                <div class="control">
                    <label class="label">Aktuelles Passwort</label>
                    <input class="input" type="password" required v-model="input.currentPassword">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <label class="label">Neues Passwort</label>
                    <input class="input" type="password" pattern=".{6,}" title="Mindestens 6 Zeichen benötigt" required v-model="input.newPassword">
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <label class="label">Neues Passwort wiederholen</label>
                    <input class="input" type="password" required v-model="input.repeat">
                </div>
            </div>
            <button class="button is-primary is-pulled-right" @click="submit()">Speichern</button>
        </form>
    </div>
</template>

<script>
import {API} from '@/assets/ts/api'
export default {
    data() {
        return {
            notification: {
                msg: '',
                isError: false,
            },
            input: {
                currentPassword: '',
                newPassword: '',
                repeat: ''
            }
        }
    },   
    methods: {
        submit() {
            const {currentPassword, newPassword, repeat} = this.input;
            if (currentPassword === '') {
                return false;
            }
            if (newPassword.length < 6) {
                return false;
            }
            if (newPassword != repeat) {
                this.notification.msg = 'Passwörter stimmen nicht überein';
                this.notification.isError = true;
                return false;
            }
            API.changePassword(currentPassword, newPassword, repeat).then(() => {
                this.notification.msg = 'Änderung gespeichert';
                this.notification.isError = false;
            }).catch((error) => {
                const data = error.response.data;
                switch (data) {
                    default:
                    this.notification.msg = 'Passwort falsch';
                    this.notification.isError = true;
                }
            })
        },
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .75s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
